import { apiService } from './apiService'

const buildPropertyParams = ({ page, limit, sort, municipalities = [], districts = [], layouts = [], displayOptions = [], priceRange, search = '' }) => {
  const params = new URLSearchParams()
  if (page != null) params.set('page', page.toString())
  if (limit != null) params.set('limit', limit.toString())
  if (sort) params.set('sort', sort)
  if (districts.length > 0) params.set('districts', districts.join(','))
  if (municipalities.length > 0) params.set('municipalities', municipalities.join(','))
  if (layouts.length > 0) params.set('layouts', layouts.join(','))
  if (displayOptions.length > 0) params.set('options', displayOptions.join(','))
  if (priceRange?.min > 0) params.set('minPrice', priceRange.min.toString())
  if (priceRange?.max < 30000000) params.set('maxPrice', priceRange.max.toString())
  if (typeof search === 'string' && search.trim()) params.set('search', search.trim())
  return params
}

export const propertiesService = {
  // Fetch properties
  async fetchProperties(request) {
    try {
      const { offerType, type, region } = request
      const params = buildPropertyParams({ page: 1, limit: 100, sort: 'date-desc', ...request })
      return await apiService.get(`/api/properties/${offerType}/${type}/${region}?${params}`)
    } catch (error) {
      console.error('Error fetching properties:', error)
      throw error
    }
  },

  async fetchPropertyMapPoints(request) {
    const { offerType, type, region } = request
    const params = buildPropertyParams(request)
    return apiService.get(`/api/property-map/${offerType}/${type}/${region}?${params}`)
  },

  async fetchLocationFacets({ offerType, type, region, municipalities = [] }) {
    const params = new URLSearchParams({ offerType, type, region })
    if (municipalities.length > 0) params.set('municipalities', municipalities.join(','))
    return apiService.get(`/api/locations/facets?${params}`)
  },

  // Fetch analytics data
  async fetchAnalytics(region) {
    try {
      return await apiService.get(`/api/analytics/${region.toLowerCase()}`)
    } catch (error) {
      console.error('Error fetching analytics:', error)
      throw error
    }
  },

  // Fetch districts for a region
  async fetchDistricts(region) {
    try {
      return await apiService.get(`/api/districts/${region}`)
    } catch (error) {
      console.error('Error fetching districts:', error)
      throw error
    }
  },
}
